"use client";

import React from "react";
import { Wrench, Image as ImageIcon, Mail, MapPin, Search, Phone } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";

/**
 * WebsiteForTradespeople — Section 4: 6 Branchen-Features
 * Drop-in für: src/pages/WebsiteForTradespeople/sections/BranchenFeatures.tsx
 */

const features = [{
  icon: Wrench,
  title: "Leistungsübersicht",
  description: "Stellen Sie alle Ihre Dienstleistungen übersichtlich dar — vom Malerservice bis zur Komplettrenovation."
}, {
  icon: ImageIcon,
  title: "Referenzen-Galerie",
  description: "Zeigen Sie Ihre besten Projekte mit Bildern. Vorher/Nachher-Vergleiche schaffen Vertrauen bei neuen Kunden."
}, {
  icon: Mail,
  title: "Anfrage-Formular",
  description: "Kunden beschreiben ihr Projekt direkt auf Ihrer Website. Sie erhalten die Anfrage per E-Mail — schnell und unkompliziert."
}, {
  icon: MapPin,
  title: "Einzugsgebiet zeigen",
  description: "Google Maps mit Ihrem Einzugsgebiet. Kunden sehen sofort, ob Sie in ihrer Region arbeiten."
}, {
  icon: Search,
  title: "Lokale Google-Suche",
  description: 'Automatische SEO für „[Ihr Handwerk] + [Ihre Stadt]". Neue Kunden finden Sie direkt über Google.'
}, {
  icon: Phone,
  title: "Click-to-Call",
  description: "Auf dem Handy: Ein Tipp auf die Nummer und der Kunde ruft direkt an. Keine umständlichen Kontaktwege."
}];
export default function BranchenFeatures() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section className="bg-background py-20 md:py-24">
      <div ref={ref} className={`max-w-7xl mx-auto px-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center max-w-3xl mx-auto mb-14 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-foreground mb-4 leading-tight">
            Speziell für Handwerker gebaut
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground">
            Alles, was Ihr Betrieb online braucht.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((f, i) => <div key={i} className="group bg-card border border-border rounded-xl p-7 hover:border-primary/40 hover:shadow-xl transition-all duration-300">
              <div className="mb-5 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 text-primary group-hover:bg-primary group-hover:text-white transition-colors">
                <f.icon className="w-6 h-6" strokeWidth={1.5} />
              </div>
              <h3 className="text-xl font-bold text-foreground mb-2 tracking-tight">
                {f.title}
              </h3>
              <p className="text-base leading-relaxed text-muted-foreground">
                {f.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}